module.exports = __webpack_public_path__ + "static/media/ic-chat.5b74ac91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-chat.svg
// module id = 610
// module chunks = 14